/**
 * Greek font for jsPDF (offer PDF export).
 * Loads base64 font from public/fonts/greek-font-base64.txt when present.
 * See public/fonts/README.md for how to generate that file.
 */

let cachedBase64: string | null = null;
const FONT_URL = `${process.env.PUBLIC_URL || ''}/fonts/greek-font-base64.txt`;
const FONT_ID = 'NotoSansGreek';

export async function fetchGreekFontBase64(): Promise<string | null> {
  if (cachedBase64 !== null) return cachedBase64;
  try {
    const res = await fetch(FONT_URL);
    if (!res.ok) return null;
    const text = await res.text();
    const base64 = text.trim();
    if (!base64 || base64.length < 100) return null;
    cachedBase64 = base64;
    return base64;
  } catch {
    return null;
  }
}

export function registerGreekFont(doc: import('jspdf').jsPDF, base64: string): boolean {
  try {
    const api = doc as any;
    if (typeof api.addFileToVFS !== 'function') return false;
    const fileName = `${FONT_ID}-normal.ttf`;
    api.addFileToVFS(fileName, base64);
    doc.addFont(fileName, FONT_ID, 'normal');
    // Register same font as 'bold' so setFont(id, 'bold') uses Greek glyphs instead of falling back to Helvetica-Bold (no Greek).
    doc.addFont(fileName, FONT_ID, 'bold');
    return true;
  } catch {
    return false;
  }
}

export const GREEK_FONT_ID = FONT_ID;
